
<div class="dialog-content">

    <div class="modal-header">
      <!-- <h4 class="modal-title">{{title}}</h4> -->
      <button type="button" class="btn-close" aria-label="Close" (click)="dialogRef.close(false)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  
    <mat-dialog-content>
      <div class="modal-body" style="text-align: center;">
        {{confirmMessage}}
        
      </div>
    </mat-dialog-content>
  
    <mat-dialog-actions class="modal-footer" align="end">
    <div class="action-bar" >
        <button type="button" class="btn-create" style="color: white;margin-left: 15px;"  (click)="dialogRef.close(false)">Cancel</button>
    </div>
    <div class="action-bar" >
      <button type="submit" class="btn-create" style="color: white;"   (click)="dialogRef.close(true)">Confirm</button>
  </div>
    </mat-dialog-actions>
    
  
  </div>